import React, { PropsWithChildren } from 'react';
import { useDroppableHeaderContext } from '../droppableHeaderV2.hook';
import ChevronUpGlyph from '../../../../assets/icons/Glyph/ChevronUpGlyph';
import ChevronDownGlyph from '../../../../assets/icons/Glyph/ChevronDownGlyph';
import CanonicalKeyGlyph from '../../../../assets/icons/Glyph/CanonicalKeyGlyph';
import classNames from 'classnames';

type TitleAndOptionsProps = PropsWithChildren<{
  title: string;
}>;

export function DroppableHeaderTitleAndOptions({ title, children }: TitleAndOptionsProps) {
  const { color, isCanonical, collapseAll, glyphColor, textColor } = useDroppableHeaderContext();
  const canonicalKeyColorValue = isCanonical ? '#FFFFFF' : '#5F7803';

  return (
    <div className='drag-header__options_row'>
      <span className='mr-15 pointer p-5'>
        {collapseAll ? <ChevronUpGlyph color={glyphColor} /> : <ChevronDownGlyph color={glyphColor} />}
      </span>
      <span className='header-badge mr-15'>A</span>
      {color === 'GREEN' && (
        <div className='mr-15 icon-container' data-testid='canonical-key-glyph'>
          <CanonicalKeyGlyph color={canonicalKeyColorValue} />
        </div>
      )}
      <span
        className={classNames(`${textColor}`, 'mr-15', {
          'text-strong': color === 'GREEN'
        })}>
        {title || 'Default Text'}
      </span>
      {color !== 'BLUE' && <div className='drag-header__options_row gap-8'>{children}</div>}
    </div>
  );
}
